module.exports = "./img/desktop_logo.a438604.png";